module.exports = __webpack_public_path__ + "static/img/collapse_r.706a99c0.svg";